import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import KeenSlider, { KeenSliderInstance } from "keen-slider"

@Component({
  selector: 'app-xn-carousel',
  standalone: false,
  templateUrl: './xn-carousel.component.html',
  styleUrls: ['./xn-carousel.component.sass']
})
export class XnCarouselComponent implements OnInit, OnDestroy {

  @Input('images') images: string[] = [];

  @ViewChild("sliderRef") sliderRef?: ElementRef<HTMLElement>;

  currentSlide: number = 0
  dotHelper: Array<Number> = []
  slider: KeenSliderInstance | null = null

  ngOnInit(): void {

  }

  initSlider(){
    if (!this.sliderRef) {
      return;
    }
    this.slider = new KeenSlider(this.sliderRef.nativeElement, {
      initial: this.currentSlide,
      slideChanged: (s) => {
        this.currentSlide = s.track.details.rel
      },
    })
    
    this.dotHelper = this.slider?.track?.details?.slides?.length ? [
      ...Array(this.slider?.track?.details?.slides?.length).keys(),
    ] : [];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initSlider();
    });
  }

  updateSlider(){
    if(!this.slider){
      return;
    }
    this.slider.update();
    this.dotHelper = [
      ...Array(this.slider.track.details.slides.length).keys(),
    ];
  }

  ngOnDestroy(): void {
    if (this.slider) this.slider.destroy()
  }

  prev() {
    this.slider?.prev()
  }

  moveToIndex(index: number) {
    this.slider?.moveToIdx(index);
  }

  carouselIndex = 0;
  galleyImageState = {
    visible: false,
    activeIndex: 0,
    images: [],
    responsiveOptions: [
      {
        breakpoint: '1024px',
        numVisible: 5
      },
      {
        breakpoint: '768px',
        numVisible: 3
      },
      {
        breakpoint: '560px',
        numVisible: 1
      }
    ]
  }
  onGalleryChanged(index: number) {
    this.carouselIndex = index;
  }

  showGallery(index: number) {
    this.galleyImageState = {
      ...this.galleyImageState,
      images: this.images as any,
      activeIndex: index,
      visible: true
    }
  }

  activeIndicatorSize = 7;
  getIndicatorSize(index: number): string {
    const size = this.activeIndicatorSize - (Math.abs(index - this.carouselIndex) * 1);
    return size > 0 ? `${size}px` : `1px`;
  }
}
